export enum ColorType {
  Red = '#ff8a80',
  Green = '#43a047',
  Blue = '#1a8bb5',
  Gray = '#7e8894',
}
